import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import * as M from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import styled from 'styled-components';

import * as C from '../../../../../../ui/common/CommonStyles';

import AiAgentTabs from '../../../Common/ui/AiAgentTabs';
import { buildSearchString } from '../../../utils/buildSearchString';
import AsCsFileUploadModal from './asCsFileUploadModal';

import type { ReactNode } from 'react';

interface IAsCsPageLayoutProps {
  children: ReactNode;
}

const SubTabList = styled(M.Tabs.List)`
  && {
    border-bottom: 0;
  }

  &&::before {
    display: none;
  }
`;

export default function AsCsPageLayout({ children }: IAsCsPageLayoutProps) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { companyId } = useParams<{ companyId: string }>();
  const [searchParams] = useSearchParams();
  const [uploadModalOpened, { open: openUploadModal, close: closeUploadModal }] = useDisclosure(false);
  const companyName = searchParams.get('companyName') || '';
  const activeTab = pathname.includes('/ascs/file') ? 'files' : 'list';

  const handleTabChange = (value: string | null) => {
    if (!value) return;

    const nextPath =
      value === 'files'
        ? `/admin/management/aiagent/company/${companyId}/ascs/file`
        : `/admin/management/aiagent/company/${companyId}/ascs`;

    navigate(
      `${nextPath}${buildSearchString({
        companyName,
      })}`,
    );
  };

  return (
    <div>
      {/* <C.TitleBox>
        <div className="title">AS/CS 관리</div>
      </C.TitleBox> */}
      <C.ListBox>
        <M.Stack gap="lg">
          <M.Flex
            gap="md"
            align="center"
            justify="space-between"
            style={(theme) => ({
              border: `1px solid ${theme.colors.gray[3]}`,
              backgroundColor: theme.colors.gray[0],
              borderRadius: theme.radius.sm,
              padding: theme.spacing.sm,
            })}
          >
            <M.Box>
              <M.Text size="xs" c="gray.6">
                거래처명
              </M.Text>
              <M.Text fw={500}>{companyName}</M.Text>
            </M.Box>
          </M.Flex>

          <M.Box>
            <AiAgentTabs />
            <M.Flex align="flex-end" justify="space-between" gap="md" pt="xs">
              <M.Tabs color="blue" value={activeTab} onChange={handleTabChange} style={{ flex: 1 }}>
                <SubTabList>
                  <M.Tabs.Tab value="list">AS/CS 목록</M.Tabs.Tab>
                  <M.Tabs.Tab value="files">업로드 목록</M.Tabs.Tab>
                </SubTabList>
              </M.Tabs>
              <M.Button color="secondary" onClick={openUploadModal}>
                파일 업로드
              </M.Button>
            </M.Flex>
          </M.Box>

          {children}
        </M.Stack>
      </C.ListBox>

      {uploadModalOpened && (
        <AsCsFileUploadModal opened={uploadModalOpened} onClose={closeUploadModal} companyName={companyName} />
      )}
    </div>
  );
}
